module.exports = __webpack_public_path__ + "img/icon-语文@2x.baf417ac.png";